import { Box, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const DropOverlay = styled("div")(({ theme }) => ({
  display: "none",
  visibility: "hidden",
  zIndex: 900,
  backgroundColor: "transparent",
  position: "absolute",
  left: 0,
  right: 0,
  pointerEvents: "none",
  width: "100%",
  height: "20px",
  transform: "translate(0px, -10px)",

  "&:before": {
    content: "''",
    width: "10px",
    height: "10px",
    position: "absolute",
    border: `2px solid ${theme.palette.info.light}`,
    borderRadius: "50%",
    left: 0,
    right: 0,
    transform: "translate(-100%, calc(50% + 1px))",
  },

  "&:after": {
    content: "''",
    borderTop: `2px solid ${theme.palette.info.light}`,
    width: "100%",
    height: "100%",
    position: "absolute",
    left: 0,
    right: 0,
    transform: "translate(0, 50%)",
  },
}));

export const DropProgress = styled(DropOverlay)(() => ({
  display: "block",
  visibility: "visible",

  "&:before": {
    animation: "1s ease-in-out 0.5s infinite normal none bottomToolbarPulsing",
  },

  "&:after": {
    animation: "1s ease-in-out 0.5s infinite normal none bottomToolbarPulsing",
  },
  "@keyframes bottomToolbarPulsing": {
    "0%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.4,
    },
    "100%": {
      opacity: 1,
    },
  },
}));

export const RateChildrenCountBadge = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: "calc(-1 * 15px)",
  transform: "translate(-50%, -1px)",
  borderRadius: "50% !important",
  backgroundColor: theme.palette.grey[600],
  width: "18px",
  scale: "1",
  fontSize: theme.typography.pxToRem(12),
  color: theme.palette.common.white,
  zIndex: 1,
  textAlign: "center",
}));

export const ExpandedEnvelope = styled("div", {
  shouldForwardProp: (prop) => prop !== "isExpanded" && prop !== "isWrapper",
})<{ isExpanded?: boolean; isWrapper?: boolean }>(({ theme, isExpanded, isWrapper }) => ({
  ...(isWrapper
    ? {}
    : {
        marginTop: theme.spacing(1),
        backgroundColor: isExpanded ? alpha("#cccccc", 0.1) : undefined,
        outline: `1px solid var(--children-outline-color)`,
        borderRadius: `${theme.shape.borderRadius}px !important`,
      }),
}));
